
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import Account from '@/api/models/Account'
import { RootStateMutations } from '@/store/mutations'

@Component({
    components: {
        BaseLayout
    }
})

export default class Accounts extends BaseLayout {
    @Getter('accounts')
    accounts!: Array<Account>

    @Action('loadAccounts')
    loadAccounts!: () => Promise<void>

    @Action('updateAccount')
    updateAccount!: (account: Account) => Promise<void>

    @Action('selectAccount')
    selectAccount!: (account: Account) => void

    @Action('createAccount')
    addAccount!: (account: Account) => Promise<void>

    @Action('refreshToken')
    refreshToken!: (accountId: number) => Promise<void>

    private isAccountCreating = false
    private showPopup = false
    private accountLogin = ''
    private showRefreshTokenWarning = false
    private accountName = ''
    private accountId = 0
    private apiKeyToken = ''
    private isLoading = false

    async created (): Promise<void> {
        this.$store.commit(RootStateMutations.setLoading, true)
        await this.handleCallback(async () => {
            await this.loadAccounts()
        })
        this.$store.commit(RootStateMutations.setLoading, false)
    }

    async showCreatePopup (): Promise<void> {
        this.resetForm()
        this.showPopup = true
        this.isAccountCreating = true
    }

    async chooseAccount (account: Account): Promise<void> {
        this.selectAccount(account)
        await this.$router.push({ name: 'account_campaigns' })
    }

    async showNamePopup (account: Account): Promise<void> {
        this.accountId = Number(account.id)
        this.isAccountCreating = false
        this.accountName = account.name
        this.showPopup = true
        this.apiKeyToken = account.apiKeyToken === null ? '' : account.apiKeyToken
    }

    async changeName (accountId: number, accountName: string, apiKeyToken: string): Promise<void> {
        const account: Account = {
            id: accountId,
            name: accountName,
            apiKeyToken: apiKeyToken,
            login: '',
            tokenStorage: null
        }

        this.isLoading = true

        await this.$refs.baseLayout.handleRequest({
            tryBody: async () => await this.updateAccount(account),
            onSuccess: () => this.$refs.baseLayout.showSuccess(this.$t('accounts.success')),
            onFailure: (errorMsg: string) => this.$refs.baseLayout.showError(errorMsg),
            onFinal: () => this.resetForm()
        })
    }

    async createAccount (login: string, accountName: string, apiKeyToken: string): Promise<void> {
        const account: Account = {
            name: accountName,
            apiKeyToken: apiKeyToken,
            login: login,
            tokenStorage: null
        }

        this.isLoading = true

        await this.$refs.baseLayout.handleRequest({
            tryBody: async () => await this.addAccount(account),
            onSuccess: () => this.$refs.baseLayout.showSuccess(this.$t('accounts.success')),
            onFailure: (errorMsg: string) => this.$refs.baseLayout.showError(errorMsg),
            onFinal: () => this.resetForm()
        })
    }

    private resetForm (): void {
        this.showPopup = false
        this.isAccountCreating = false
        this.isLoading = false
        this.accountId = 0
        this.accountName = ''
        this.apiKeyToken = ''
        this.accountLogin = ''
    }
}
